/*
 * "See More / See Less" text expander (snippets/rv-see-more.liquid), site-wide.
 *
 * The toggle stays hidden unless the clamped text actually overflows. Each expander is watched
 * with a ResizeObserver, so it re-checks when the text becomes visible (an accordion or tab
 * opening), on resize, and on font load — and a MutationObserver picks up expanders added later
 * (AJAX collection filtering, theme editor section reloads).
 */
(function () {
  var resizeObserver = window.ResizeObserver
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var root = entry.target.closest('[data-rv-see-more]');
          if (root) sync(root);
        });
      })
    : null;

  function sync(root) {
    var content = root.querySelector('[data-rv-see-more-content]');
    var toggle = root.querySelector('[data-rv-see-more-toggle]');
    if (!content || !toggle) return;
    if (root.classList.contains('is-expanded')) {
      toggle.hidden = false;
      return;
    }
    // Hidden (e.g. inside a closed accordion): nothing to measure yet; the observer re-checks.
    if (content.clientHeight === 0) return;
    toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rv-see-more]').forEach(function (root) {
      if (!root.__rvSeeMore) {
        root.__rvSeeMore = true;
        var content = root.querySelector('[data-rv-see-more-content]');
        if (resizeObserver && content) resizeObserver.observe(content);
      }
      sync(root);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-rv-see-more-toggle]');
    if (!toggle) return;
    var root = toggle.closest('[data-rv-see-more]');
    var expanded = root.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded);
    toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    sync(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      init();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
